/* ============================================================
   ATELIER HAÏYA — main.js (Shopify)

   Initialisation globale :
   - Gestion des erreurs d'image
   - Annonces accessibles (aria-live) pour les mises à jour du panier
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  initImageFallbacks();
});

/* ----------------------------------------------------------
   Annonces panier (aria-live) — utilisé par cart-drawer.liquid,
   main-cart.liquid et main-product.liquid après chaque opération
   ---------------------------------------------------------- */

function announceCartUpdate(message) {
  const region = document.getElementById('cart-live-region');
  if (!region) return;
  region.textContent = '';
  /* Force la relecture même si le message est identique au précédent */
  window.setTimeout(() => { region.textContent = message; }, 50);
}

window.CartA11y = { announce: announceCartUpdate };

/* ----------------------------------------------------------
   Fallback images cassées
   ---------------------------------------------------------- */

function initImageFallbacks() {
  document.querySelectorAll('img').forEach(img => {
    img.addEventListener('error', () => {
      img.style.visibility = 'hidden';
    });
  });
}
